// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"315":"ucare-panel-chunk","923":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"283":"98ba3230","315":"053a281b","923":"fdc3c9a3"}[chunkId] + ".chunk.js";
};